import { render } from "./EditGM.vue?vue&type=template&id=19b22d49"
import script from "./EditGM.vue?vue&type=script&lang=js"
export * from "./EditGM.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Products/GMWorkFlow/EditGM.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19b22d49"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19b22d49', __exports__)) {
    api.reload('19b22d49', __exports__)
  }
  
  module.hot.accept("./EditGM.vue?vue&type=template&id=19b22d49", () => {
    api.rerender('19b22d49', render)
  })

}


export default __exports__